export default __webpack_public_path__ + "static/media/logo.84013b5e.jpg";